import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG } from '@common/utility/globals';
import { Router } from '@angular/router';
import { SentryService } from '@app/config/sentry.service';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { GoogleTagManagerClient } from './shared/qplanning-commons/analytics/google-tag-manager.client';
import { AnalyticsClient } from './shared/qplanning-commons/analytics/analytics-client.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly document = inject(DOCUMENT);
  private readonly sentryService = inject(SentryService); // Required to initialize Sentry!
  private readonly translateService = inject(TranslateService);
  private readonly gtmClient = inject(GoogleTagManagerClient);
  private readonly analyticsClient = inject(AnalyticsClient);

  private static getUserLanguageFromStorage() {
    return window.localStorage.getItem('language') ?? DEFAULT_LANG;
  }

  ngOnInit(): void {
    this.gtmClient.init({
      gtm_id: 'GTM-TSK6QL86'
    });

    this.analyticsClient.capturePageViews();
    this.analyticsClient.captureMouseClicks();

    this.translateService.onLangChange
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((langChangeEvent) => langChangeEvent.lang)
      )
      .subscribe((lang) => (this.document.documentElement.lang = lang));

    this.translateService.setDefaultLang(DEFAULT_LANG);
    this.translateService.use(AppComponent.getUserLanguageFromStorage());
  }


}
